module.exports = __webpack_public_path__ + "img/4e3adc36.png";